module.exports = __webpack_public_path__ + "img/libra-4.e1404aeb.png";